import React, { Children, FC, ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';

import { Icon } from '@components/shared/icon/Icon';

import classes from './TreeItem.module.scss';

interface ITreeItemProps {
  label: ReactElement;
  expand?: boolean;
  children?: ReactNode;
}

const TreeItem: FC<ITreeItemProps> = ({ children, expand, label }) => {
  const [expanded, setExpanded] = useState(expand || false);
  const [maxHeight, setMaxHeight] = useState('0px');
  const wrapperRef = useRef<HTMLUListElement>(null);
  const hasChildren = Children.count(children) > 0;

  useEffect(() => {
    if (expanded && wrapperRef.current) {
      setMaxHeight(`${wrapperRef.current.scrollHeight}px`);
    } else {
      setMaxHeight('0px');
    }
  }, [expanded]);

  const toggleExpand = (event: React.MouseEvent) => {
    event.stopPropagation();
    setExpanded(!expanded);
  };

  return (
    <ul className={clsx(classes.ul, { [classes.hasChildren]: hasChildren })} role="treeitem" aria-selected="false">
      <li onClick={toggleExpand}>
        <div className={classes.container}>
          {hasChildren ? (
            <Icon
              size={12}
              offset={5}
              type="arrowExpand"
              className={clsx(classes.arrow, { [classes.arrowExpand]: expanded })}
              onClick={toggleExpand}
            />
          ) : null}
          {label}
        </div>
        {hasChildren ? (
          <ul className={classes.wrapper} style={{ maxHeight }} ref={wrapperRef}>
            {children}
          </ul>
        ) : null}
      </li>
    </ul>
  );
};

export default TreeItem;
